<script>
export default {
  components: {
    AppBar: () => import('@components/structure/app-bar.vue'),
    NavDrawer: () => import('@components/structure/nav-drawer.vue'),
    Footer: () => import('@components/structure/footer.vue'),
  },
}
</script>

<template>
  <v-app>
    <NavDrawer />
    <AppBar />

    <v-main class="mb-10">
      <slot />
    </v-main>

    <Footer />
  </v-app>
</template>

<style>
#app {
  background-color: var(--v-background-base);
}
</style>
